module.exports = __webpack_public_path__ + "static/media/hubrise_logo.453cea86.png";